import React, { useEffect, useState } from "react";
import TldrNavbar from "../_components/common/TldrNavbar";
import { useHistory } from "react-router-dom";
import Sidebar from "../_components/home/Sidebar";
import {
  BOTTOM_BAR,
  DASHBOARD_SIDEBAR_MENU,
  MAIN_CONTAINER_SCROLLABLE_TARGET_ID,
  TOP_BAR,
  DASHBOARD_KEY,
  TEMPLATES_KEY,
  PROJECTS_KEY,
  AI_ASSISTANT_KEY,
  AI_KEY,
  FOLDERS_KEY,
  TEAM_TEMPLATES_KEY,
  COMPONENTS_KEY,
  MY_ASSETS_KEY,
  BRANDKIT_KEY,
  PUBLISHING_KEY,
  PLANNER_KEY,
  ANALYTICS_KEY,
  DOCUMENTS_KEY,
  FAVOURITES_KEY,
} from "../_utils/constants";
import { IntercomCustomIcon } from "../_components/styled/home/statelessView";
import {
  USER_HOME,
  QUICK_START,
  MY_FOLDERS,
  LAYOUTS,
  BRANDKIT,
  ROOT,
  SETTINGS,
  MY_ACCOUNT,
} from "../_utils/routes";
import { BrandLogo, BrandTextLogo } from "../_components/common/statelessView";
import {
  StyledSidebar,
  FloatingButton,
  StyledDashboardContent,
} from "./TldrHomeBaseStyles";
import {
  analyticsTrackEvent,
  showBottomMenuBar,
  showCreatePresetFloatingButton,
} from "../_utils/common";
import { batch, connect } from "react-redux";
import PropTypes from "prop-types";
import { withRouter } from "react-router-dom";
import { resetStories } from "../_actions/storiesActions";
import { resetFolders } from "../_actions/folderActions";
import { BACK_FROM_STUDIO } from "../_actions/types";
import { closeSidebar, openSidebar } from "../_actions/sidebarSliderActions";
import { redirect } from "../_actions/commonAction";
import { studioFooterColor } from "../_components/styled/variable";
import Tabbar from "../TldrStoryDetail/Tabbar";
import { greyDark } from "../_components/styled/variable";
import { handleHTTPError } from "../_actions/errorHandlerActions";
import { FaAngleDoubleLeft, FaAngleDoubleRight, FaCog, FaPlus } from "react-icons/fa";
import { getSubscription } from "../_actions/subscriptionActions";
import axios from "axios";
import LanguageSelector from "../_components/common/LanguageSelector";
import { Box, Icon } from "@chakra-ui/react";
import { useTranslation } from "react-i18next";
import { Menu, MenuItem, SubMenu } from "react-pro-sidebar";

function TldrHomeBase(props) {
  const signal = axios.CancelToken.source();
  const history = useHistory();
  const { t } = useTranslation(["common"]);
  const isCollapsed = !props.sidebarSlider.isSidebarOpen;
  const [path, setPath] = useState(props.match.path);
  const [navBackgroundColor, setNavBackgroundColor] = useState(
    `${props.match.path === QUICK_START || props.match.path === ROOT
      ? "transparent"
      : studioFooterColor
    }`
  );

  const toggle = () => {
    if (isCollapsed) {
      props.openSidebar();
    } else {
      props.closeSidebar();
    }
  };

  const isItemActive = (item) => {
    if (!item?.extraData?.path) {
      return;
    }
    if (Array.isArray(item?.extraData?.path)) {
      return item?.extraData?.path.some((panelPath) => {
        return (
          panelPath === props?.match?.path ||
          panelPath === props?.location?.pathname
        );
      });
    } else {
      return (
        item?.extraData?.path === props?.match?.path ||
        item?.extraData?.path === props?.location?.pathname ||
        item?.extraData?.altPath === props?.location?.pathname
      );
    }
  };

  const onTopbarItemClick = (item) => {
    switch (item?.extraData?.action) {
      case "Toggle":
        toggle();
        break;
      case "Dashboard":
        if (path !== QUICK_START && path !== USER_HOME) {
          props.resetStories();
          history.push(QUICK_START);
        }
        break;
      default:
      // Do nothing
    }
  };

  const openSettings = () =>{
    batch(() => {
      props.resetStories();
      props.closeSidebar();
      history.push(SETTINGS);
    });
  }

  const onMenuItemClick = (item, from) => {
    switch (item.key) {
      case DASHBOARD_KEY:
        if (path !== QUICK_START && path !== USER_HOME) {
          props.resetStories();
          history.push(QUICK_START);
        }
        break;
      case PUBLISHING_KEY:
      case PLANNER_KEY:
      case ANALYTICS_KEY:
      case TEMPLATES_KEY:
      case PROJECTS_KEY:
      case AI_ASSISTANT_KEY:
      case FAVOURITES_KEY:
      case DOCUMENTS_KEY:
      case AI_KEY:
        if (path !== item?.extraData?.path) {
          batch(() => {
            props.resetStories();
            props.closeSidebar();
            history.push(item?.extraData?.path);
          });
        }

        if (item?.extraData?.analyticsTrackLabel) {
          analyticsTrackEvent(item?.extraData?.analyticsTrackLabel, {
            location: "sidebar",
          });
        }
        break;
      case FOLDERS_KEY:
        if (path !== MY_FOLDERS) {
          props.resetFolders();
          history.push(MY_FOLDERS);
        }
        break;
      case MY_ASSETS_KEY:
      case TEAM_TEMPLATES_KEY:
      case COMPONENTS_KEY:
        if (path !== item?.extraData?.path) {
          batch(() => {
            props.resetAssets();
            props.closeSidebar();
            history.push(item?.extraData?.path);
          });
        }
        break;
      case BRANDKIT_KEY:
        if (path !== BRANDKIT) {
          history.push(BRANDKIT);
        }
        break;
      default:
      // Do nothing
    }
    if (props.isMobileView) {
      props?.closeSidebar();
    }
  };

  const sidebarFooter = (
    <>
      {process.env.REACT_APP_DEBUG === "True" && (
        <LanguageSelector isCollapsed={isCollapsed} />
      )}

      <Menu iconShape="square">
        <MenuItem icon={<FaCog />} onClick={openSettings}>{t("go_to_settings")}</MenuItem>
        <MenuItem icon={!isCollapsed ? <FaAngleDoubleLeft /> : <FaAngleDoubleRight />} onClick={toggle}>{t("close")}</MenuItem>
      </Menu>
    </>
  );

  const sidebarHeader = (
    <div onClick={toggle}>
      {isCollapsed ? <BrandLogo /> : <BrandTextLogo height={40} width={160} />}
    </div>
  );

  const handleScroll = (event) => {
    const isTransparent = event.target.scrollTop <= 50;
    if (isTransparent) {
      setNavBackgroundColor("transparent");
    } else {
      setNavBackgroundColor(studioFooterColor);
    }
  };

  useEffect(() => {
    setPath(props.match.path);
    if (
      props.isMobileView &&
      (props.match.path === QUICK_START || props.match.path === ROOT)
    ) {
      setNavBackgroundColor("transparent");
      document
        .querySelector(".tldr-dashboard-content")
        .addEventListener("scroll", handleScroll);
    } else {
      setNavBackgroundColor(studioFooterColor);
      document
        .querySelector(".tldr-dashboard-content")
        .removeEventListener("scroll", handleScroll);
    }
    return () => {
      const homeBaseHTMLElement = document.querySelector(
        ".tldr-dashboard-content"
      );
      if (homeBaseHTMLElement) {
        homeBaseHTMLElement.removeEventListener("scroll", handleScroll);
      }
    };
  }, [props.match.path]);

  useEffect(() => {
    props.getSubscription();
  }, []);

  const [dashboardSidebarMenu, setDashboardSidebarMenu] = useState([
    ...DASHBOARD_SIDEBAR_MENU,
  ]);

  const [bottomMenu, setBottomMenu] = useState(BOTTOM_BAR);

  useEffect(() => {
    const { canViewMyLibrary } = props.workspacePermissionChecks;
    // To clone array without reference
    let menuItems = DASHBOARD_SIDEBAR_MENU.map((item, index) => {
      return { ...item };
    });

    if (!canViewMyLibrary) {
      menuItems = menuItems.filter((item, index) => item.title !== "Library");
    }

    setDashboardSidebarMenu(menuItems);
  }, [props.workspacePermissionChecks]);

  return (
    <div className="tldr-wrapper tldr-wrapper-md-row tldr-wrapper-sm-col">
      {props.hidesidebar ? null : (
        <Sidebar
          collapsed={isCollapsed}
          footer={sidebarFooter}
          header={sidebarHeader}
          menu={dashboardSidebarMenu}
          onItemClick={onMenuItemClick}
          isItemActive={isItemActive}
          tooltip="true"
          styles={StyledSidebar}
          {...props}
        />
      )}

      <Box
        display={["block", "block", "block", "none"]}
        position="sticky"
        width="full"
        flexDirection="row"
        zIndex={6}
      >
        <Tabbar
          tabs={TOP_BAR}
          onItemClick={onTopbarItemClick}
          isItemActive={isItemActive}
          justifyContent="space-between"
          {...props}
          style={{ background: greyDark }}
        ></Tabbar>
      </Box>
      <StyledDashboardContent
        className={"tldr-dashboard-content"}
        id={MAIN_CONTAINER_SCROLLABLE_TARGET_ID}
      >
        <TldrNavbar
          onTabChange={(tab) => {
            history.push(tab);
          }}
          showBackBtn={props.hidesidebar}
        />
        {props.children}

        <IntercomCustomIcon position="absolute" />

        {showCreatePresetFloatingButton(props.match.path) && (
          <Box
            as={FloatingButton}
            display={["flex", "flex", "none", "none"]}
            zIndex={4}
            onClick={(e) => {
              e.stopPropagation();
              props.redirect(LAYOUTS, { ...props });
            }}
          >
            <Icon
              as={FaPlus}
              alignSelf="center"
              className="floating-add-product-icon "
              color="black"
            />
          </Box>
        )}
      </StyledDashboardContent>

      {showBottomMenuBar(props.match.path) ? (
        <Box
          display={["block", "block", "block", "none"]}
          position="sticky"
          bottom={0}
          zIndex={5}
          width="100%"
        >
          <Tabbar
            tabs={bottomMenu}
            onItemClick={onMenuItemClick}
            isItemActive={isItemActive}
            justifyContent="space-between"
            showLabels="true"
            {...props}
          ></Tabbar>
        </Box>
      ) : null}
    </div>
  );
}

const mapStateToProps = (state) => ({
  auth: state.auth,
  sidebarSlider: state.sidebarSlider,
  workspacePermissionChecks: state.permissions.workspacePermissionChecks,
  isMobileView: state.app.isMobileView,
  foldersPage: state.folders.foldersPage,
});

const mapDispatchToProps = (dispatch) => ({
  redirect: (location, props) => dispatch(redirect(location, props)),
  resetStories: () => dispatch(resetStories()),
  resetFolders: () => dispatch(resetFolders()),
  resetAssets: () =>
    dispatch({
      type: BACK_FROM_STUDIO,
    }),
  openSidebar: () => dispatch(openSidebar()),
  closeSidebar: () => dispatch(closeSidebar()),
  handleHTTPError: (error, props) => dispatch(handleHTTPError(error, props)),
  getSubscription: () => dispatch(getSubscription()),
});

TldrHomeBase.propTypes = {
  auth: PropTypes.object.isRequired,
  hidesidebar: PropTypes.bool.isRequired,
};

TldrHomeBase.defaultProps = {
  hidesidebar: false,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withRouter(TldrHomeBase));
